import React from "react";
import { NavigationBody } from "../Typography/Typography";
import SocialIcons from "../SocialIcons/SocialIcons";
import { StyledAppBar, StyledToolbar, StyledLink, NavigationContainer, LogoImg, SocialIconContainer } from "./elements"
import config from "../../config/config";

interface Props {
    isNotFound?: boolean
}

const Navbar: React.FC<Props> = ({ isNotFound = false }) => {
    return (
        <StyledAppBar>
            <StyledToolbar>
                <LogoImg src="./images/logo.png" alt="Moonville Farms Logo" loading="lazy" />
                {
                    (!isNotFound && <NavigationContainer>
                        <StyledLink to={config.router.home}><NavigationBody>Home</NavigationBody></StyledLink>
                        <a href="https://blog.moonvillefarms.com/" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}><NavigationBody>How to play</NavigationBody></a>
                    </NavigationContainer>)
                }

                <SocialIconContainer>
                    <SocialIcons isDark={true} buttonLocation="Top Buttons" />
                </SocialIconContainer>
            </StyledToolbar>
        </StyledAppBar>
    )
}

export default Navbar